import { CircularProgress, Dialog, DialogContent, DialogContentText } from '@mui/material';
import { FC } from 'react';

type ProgressDialogProps = {
  open: boolean;
  message: string;
  onClose: () => void;
};

const ProgressDialog: FC<ProgressDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <CircularProgress color='inherit' />
        <DialogContentText>{props.message}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default ProgressDialog;
